export default __webpack_public_path__ + "static/AkebiaCares-IDA-Access-Flashcard_Thumb-076e110185b3ec538ef2d506e1658621.jpg";